"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleObjectToString = void 0;

var styleObjectToString = function styleObjectToString(style) {
  return Object.keys(style).reduce(function (acc, key) {
    return acc + key.split(/(?=[A-Z])/).join('-').toLowerCase() + ':' + style[key] + ';';
  }, '');
};

exports.styleObjectToString = styleObjectToString;